var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cw__header"},[_c('md-icon',{staticClass:"cw__header-icon"},[_vm._v(" comment ")]),_c('h5',{staticClass:"cw__header-title"},[_vm._v(" "+_vm._s(_vm.getLocalize('commentsWidget.header'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }